var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 2.65674C8.32761 2.65674 8.59292 2.92205 8.59292 3.24933V7.39748H12.7411C13.0683 7.39748 13.3337 7.66279 13.3337 7.99007C13.3337 8.31735 13.0683 8.58266 12.7411 8.58266H8.59292V12.7308C8.59292 13.0581 8.32761 13.3234 8.00033 13.3234C7.67305 13.3234 7.40773 13.0581 7.40773 12.7308V8.58266H3.25958C2.9323 8.58266 2.66699 8.31735 2.66699 7.99007C2.66699 7.66279 2.9323 7.39748 3.25958 7.39748H7.40773V3.24933C7.40773 2.92205 7.67305 2.65674 8.00033 2.65674Z",
    fill: "#074E9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.1ebe6cb80373cd4b0159a849bc93b3b5.svg";
export { ForwardRef as ReactComponent };